<template>
  <div
    id="Maintenance"
    :style="{ 'background-image': 'url(' + bg + ')' }"
    class="d-flex align-items-center justify-content-center w-100 h-100"
  >
    <!-- for xs - sm -->
    <div
      :style="{ 'background-image': 'url(' + bgBalloon + ')' }"
      class="d-block d-lg-none position-fixed w-100 h-100 bg-balloon sm"
    ></div>
    <div class="d-block container d-lg-none row w-100">
      <div class="offset-md-2"></div>
      <div class="col-xs-12 col-md-6">
        <div class="text-center detail-en">
          Maintenance
        </div>
        <div class="text-center detail-th">
          รู้ใจกำลังปิดปรับปรุงระบบ
        </div>
        <div class="text-center detail-th">
          ขออภัยในความไม่สะดวก
        </div>
      </div>
    </div>
    <!-- for > sm -->
    <div
      :style="{ 'background-image': 'url(' + bgBalloon + ')' }"
      class="d-none d-lg-block position-fixed w-100 h-100 bg-balloon"
    ></div>
    <div class="d-none container d-lg-block row w-100">
      <div class="offset-md-2"></div>
      <div class="col-xs-12 col-md-6">
        <div class="text-center detail-en">
          Maintenance
        </div>
        <div class="text-center detail-th">
          รู้ใจกำลังปิดปรับปรุงระบบ
        </div>
        <div class="text-center detail-th">
          ขออภัยในความไม่สะดวก
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MaintenancePage',
  data() {
    return {
      bg: "/static/backgrounds/bg-404.png",
      bgBalloon: "/static/backgrounds/bg-balloon.png"
    };
  }
};
</script>

<style scoped>
#Maintenance {
  background-position: top right;
  background-size: cover;
  background-repeat: no-repeat;
  overflow-x: auto;
}
.bg-balloon {
  background-position: top right;
  background-repeat: no-repeat;
  background-size: 40%;
}
.bg-balloon.sm {
  background-size: 70%;
}
.detail-th {
  font-size: 40px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 0.97;
  letter-spacing: -0.3px;
  color: #4a4a4a;

  margin-top: 15px;
}
.detail-th.sm {
  font-size: 20px;
}
.detail-en {
  font-size: 48px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.16;
  letter-spacing: -0.2px;
  color: #4a4a4a;
}
.detail-en.sm {
  font-size: 24px;
}
</style>
